import { useQuery } from '@tanstack/react-query';

import { AuditLogClient, ReportType } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const auditLogClient = new AuditLogClient(apiBaseUrl);

function useGetAuditLogs(id: number, reportType: ReportType) {
  return useQuery({
    queryKey: [queryKeys.AuditLog.Get, id, reportType],
    queryFn: () => auditLogClient.getLogs(id, reportType),
    staleTime: 60 * 60 * 1000, // 1 hour
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

export default useGetAuditLogs;
